import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DealItem } from '../customerDashboardTypes';
import styles from './ActiveDeals.module.css';

interface ActiveDealsProps {
  deals: DealItem[];
}

const DealsIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
  </svg>
);

export const ActiveDeals: React.FC<ActiveDealsProps> = ({ deals }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.icon}><DealsIcon /></span>
        <h3 className={styles.title}>Active Deals</h3>
      </div>
      <div className={styles.grid}>
        {deals.map((deal) => (
          <div key={deal.id} className={styles.card}>
            <div className={styles.cardHeader}>
              <span className={styles.dealTitle}>{deal.title}</span>
              <span className={styles.discountBadge}>{deal.discount}</span>
            </div>
            <p className={styles.condition}>{deal.condition}</p>
            <div className={styles.cardFooter}>
              <span className={styles.expires}>{deal.expires}</span>
              <button
                type="button"
                className={styles.shopBtn}
                onClick={() => navigate('/catalog')}
              >
                Shop Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
